/**
 * Реквизиты Оператора и версия документа для юридических экранов кабинета.
 *
 * Адрес здесь — регион и город, без улицы и квартиры: раньше в этом файле лежал домашний адрес
 * с номером квартиры, и он ехал в кабинет вместе с остальными реквизитами. Часть 1 статьи 14
 * 152-ФЗ даёт субъекту право узнать адрес оператора, но публиковать адрес проживания не
 * требует — полный адрес указывается в уведомлении в Роскомнадзор и в ответах на запросы.
 */
export const PERSONAL_DATA_CONSENT_DOCUMENT_VERSION = 'от 11 сентября 2026 г.'

export const PERSONAL_DATA_CONSENT_OPERATOR = {
  legalName: 'Загумённов Дмитрий Николаевич',
  shortName: 'Загумённов Д.Н.',
  taxStatus: 'налогоплательщик налога на профессиональный доход',
  inn: '594403178891',
  address: 'Пермский край, г. Пермь',
  privacyEmail: 'support@provisium.ru',
  sites: 'provisium.ru и market.provisium.ru',
} as const
